<template>
  <v-card>
    <v-form
      lazy-validation
      ref="form"
      v-model="validForm"
      @submit.prevent="onConfirm"
    >
      <v-card-title primary-title>
        Skapa kategori
      </v-card-title>

      <v-card-text>
        <v-text-field
          :rules="[validationRules.required]"
          v-model="model.name"
          label="Kategori"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose">
          Avbryt
        </v-btn>
        <v-btn type="submit" color="primary" text>
          Spara
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import CREATE_CATEGORY_GROUP from '@/gql/categoryGroups/mutations/CreateCategoryGroup.gql'
import { validationRules } from '@/common/validationRules'
import { v4 as uuid } from 'uuid'

export default {
  name: 'MasterdataCategoriesCreate',

  data() {
    return {
      validationRules,
      validForm: true,
      model: {
        uuid: uuid(),
        name: '',
      },
    }
  },

  methods: {
    async onConfirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.createCategoryGroup()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    createCategoryGroup() {
      return this.$apollo.mutate({
        mutation: CREATE_CATEGORY_GROUP,
        variables: {
          payload: this.model,
        },

        update: (store, { data }) => {
          this.$store.set('categoryGroups/data', {
            ...this.$store.get('categoryGroups/data'),
            [data.createCategoryGroup.uuid]: data.createCategoryGroup,
          })
        },
      })
    },
  },
}
</script>
